// extracted by mini-css-extract-plugin
module.exports = {"root":"BungieIcon_root__1kZxo"};